module.exports = __webpack_public_path__ + "static/media/icon-affordable-prices.b9dc0b5c.svg";